<template>
  <div>
    <b-card no-body
            class="mb-1"
            v-for="(item, index) in preQualifications"
            :key="item.id">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <b-button block
                  v-b-toggle="'accordion-prequalification-' + index"
                  variant="info">
                  Lead Gen Qualification
        </b-button>
      </b-card-header>
      <b-collapse :id="'accordion-prequalification-' + index"
                  visible
                  accordion="accordion"
                  role="tabpanel">
        <b-card-body>
          <b-card-text>
            <CompanyPreQualificationEntry :initialPreQualification="item"
                                          :lookups="lookups"
                                          :index="index"
                                          :key="reloadKey"
                                          />
          </b-card-text>
        </b-card-body>
      </b-collapse>
    </b-card>

    <!--<CompanyTransferCreateModal :companyId="selectedCompanyId" ref="companyTransferCreateModal" />-->
  </div>
</template>

<script>
  import CompanyPreQualificationEntry from "@/components/company/prequalification/CompanyPreQualificationEntry.vue";

  export default {
    components: { CompanyPreQualificationEntry },
    props: {
      preQualifications: Array,
      lookups: Object
    },
    data() {
      return {
        reloadKey: 0
      }
    },
    watch: {
      preQualifications: {
        handler() {
          this.reloadKey++;
        }
      }
    }
  }

</script>

<style scoped>
  .table {
    font-size: 0.85em;
  }

  .label {
    text-align: right;
  }

  .label > label {
    margin-top: 6px;
  }
</style>
